import { Component, ViewEncapsulation } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon'
import { Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CarritoPopupComponent } from "../carrito-popup/carrito-popup.component";
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, MatMenuModule, MatIconModule, RouterModule, CarritoPopupComponent],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent {

  constructor(private router: Router, private translate: TranslateService, private authService: AuthService) {
  }

  public linkDisabled(route: string): boolean {
    return this.router.url === route;
  }

  public isAdminPath(): boolean {
    return this.authService.isAdminPath();
  }

  public changeLang(): void {
    console.log('previo a cambiar idioma:');
    console.log('getBrowserCultureLang', this.translate.getBrowserCultureLang());
    console.log('getBrowserLang', this.translate.getBrowserLang());
    console.log('getCurrentLang', this.translate.getCurrentLang());
    console.log('getFallbackLang', this.translate.getFallbackLang());
    console.log('getLangs', this.translate.getLangs());
    if (this.translate.getCurrentLang() === 'es-AR') {
      this.translate.use('en-US');
    } else {
      this.translate.use('es-AR');
    }
    console.log('luego de cambiar idioma:');
    console.log('getBrowserCultureLang', this.translate.getBrowserCultureLang());
    console.log('getBrowserLang', this.translate.getBrowserLang());
    console.log('getCurrentLang', this.translate.getCurrentLang());
    console.log('getFallbackLang', this.translate.getFallbackLang());
    console.log('getLangs', this.translate.getLangs());
  }

  logout() {
    this.authService.logout().subscribe(resp => {
      this.router.navigate(['/catalogo']);
    });
  }

  clickLogo() {
    if(this.isAdminPath()){
      this.router.navigate(['/admin']);
    }
    else {
      this.router.navigate(['/catalogo']);
    }
  }

}
